// extracted by mini-css-extract-plugin
export var wrapper = "movielist-module--wrapper--37zaA";